import packageJson from "../../package.json";

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.pdf.co/v1/' ;
export const USER_API_KEY = process.env.REACT_APP_USER_API_KEY;
export const API_INTEGRATION_KEY = process.env.REACT_APP_API_INTEGRATION_KEY;
export const VERSION = packageJson.version;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const PDFCO_APP_URL = process.env.REACT_APP_PDFCO_APP_URL;
export const PDFCO_APP_ORIGIN = process.env.REACT_APP_PDFCO_APP_ORIGIN;